import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import { Container, i18n } from '../../../../../symphony';
import { ActionType, RequestType } from '../../../global-interface';
import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';

import s from './LandingPageFooter.scss';

interface ILandingPageFooterProps {
  alias: string;
}

export function LandingPageFooter({
  alias,
}: ILandingPageFooterProps): JSX.Element {
  useStyles(s);
  const startLearing = () => {
    const { actions$ } = Container.take(SlLEContext, SlActions);

    actions$.next({
      type: ActionType.OnLandingPageCTAClick,
      requestType: RequestType.Parallel,
    });
  };

  return (
    <footer className="lp-landing-page-footer">
      <div className="lp-landing-page-footer__container">
        <h3 className="lp-landing-page-footer__title">
          {i18n.t(`web-lelp.${alias}-footer-title`)}
        </h3>
        <Button onClick={startLearing}>
          {i18n.t(`web-lelp.${alias}-footer-button`)}
        </Button>
      </div>
    </footer>
  );
}
